export default __webpack_public_path__ + "static/media/marble-popup.ddde6377.jpg";